import { Card, Stack, useTheme } from '@fti/design-system';
import { TagInput } from '../shared/TagInput';
import { HelpText } from '../shared/HelpText';
import { ArticlePreview } from './ArticlePreview';
import { TermBrainstormHelp } from './TermBrainstormHelp';

interface WizardStep5Props {
  subjectTerms: string[];
  onChange: (terms: string[]) => void;
  collectionIds?: string[];
}

export function WizardStep5({ subjectTerms, onChange, collectionIds = [] }: WizardStep5Props) {
  const { theme } = useTheme();

  return (
    <Stack gap="md">
      <Card variant="elevated">
        <Card.Body>
          <Stack gap="md">
            <h3 style={{ margin: 0, color: theme.colors.text.primary }}>Subject Terms</h3>
            <HelpText>
              Enter the names of the company or individuals releasing messaging. This should include variations of the
              company name and leadership names if they are highly visible (e.g., "JPMorgan", "Chase Bank", "Jamie Dimon").
              Include company names in this list even if a term generates little to no coverage.
              Each term is searched separately for the 200 paragraphs with the greatest semantic similarity.
              Hint: preview results for one term at a time so you can see the relevance and quality of each individual term.
            </HelpText>
            <TermBrainstormHelp />
            <TagInput
              tags={subjectTerms}
              onChange={onChange}
              placeholder="Add a subject term..."
            />
            {subjectTerms.length === 0 && (
              <p style={{ fontSize: '0.8rem', color: theme.colors.semantic.error.default, margin: 0 }}>
                At least one subject term is required.
              </p>
            )}
          </Stack>
        </Card.Body>
      </Card>
      <ArticlePreview
        label="Preview Subject Articles"
        terms={subjectTerms}
        collectionIds={collectionIds}
        helpText="Enter subject terms above, then click Preview to see returned articles. Not all previewed articles are retained — later stages filter out unrelated articles and select only the most relevant ones. Not all companies will be covered by every publication. Candidate articles are not displayed in any particular order."
      />
    </Stack>
  );
}
